// for graph display
export default {
  refreshRequired: false,
  heroGraphData: [{name: 'Intl Roaminf', total: 12}, {name: 'Spend Limit Active', total: 200}],
  snFilter: {},
}
